import { render } from "./WhitelabelContentLayout.vue?vue&type=template&id=4ecb007b&scoped=true&ts=true"
import script from "./WhitelabelContentLayout.vue?vue&type=script&lang=ts"
export * from "./WhitelabelContentLayout.vue?vue&type=script&lang=ts"

import "./WhitelabelContentLayout.vue?vue&type=style&index=0&id=4ecb007b&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ecb007b"]])

export default __exports__